<div class="message-popup-container">
  <div class="message-popup-content">
    @if (data()?.title) {
      <span class="message-popup-title">
        {{ data()?.title }}
      </span>
    }
    @if (data()?.description) {
      <span class="message-popup-description">
        {{ data()?.description }}
      </span>
    }
    @if (data()?.action) {
      <span class="message-popup-action">
        <u-button
          [versionNumber]="2"
          [label]="data().action.text"
          [fontIcon]="data().action.icon"
          styleType="text"
          typeElement="primary"
          sizeElement="medium"
          iconPos="right"
          (onClick)="onActionClick()"
        ></u-button>
      </span>
    }
  </div>
  <u-button class="close-button" fontIcon="times" [versionNumber]="2" [sizeElement]="'small'" (onClick)="closePopup()"> </u-button>
</div>
